import shuffle from 'lodash/shuffle';

import LoadingBar from '~/components/LoadingBar';
import useInterval from '~/hooks/useInterval';

import CompaniesIcon from './Companies.svg';
import PeopleIcon from './People.svg';
import styles from './styles';

const texts = [
  'Staying inside',
  'Washing hands',
  'Social distancing',
  'Travelling essentially',
  'Sheltering in place',
  'Calling friends',
  'Watching TV',
  'Staying 6 feet apart',
  'Supporting local restaurants',
  'Using hand sanitizer',
  'Shopping online',
  'Cleaning the house',
  'Working from home',
];
const randomText = () => shuffle(texts)[0];

const LoadingSegment = ({ type, classes, className }) => {
  const [text, setText] = useState(randomText());

  useInterval(() => {
    setText(randomText());
  }, 3000);

  return (
    <div className={classnames(classes.root, className)}>
      {type === 'Companies' ? (
        <CompaniesIcon className={classes.icon} />
      ) : (
        <PeopleIcon className={classes.icon} />
      )}
      <LoadingBar className={classes.loadingBar} />
      <span className={classes.subtitle}>{text}</span>
    </div>
  );
};

LoadingSegment.propTypes = {
  classes: PropTypes.object,
  className: PropTypes.string,
  type: PropTypes.oneOf(['Companies', 'People']).isRequired,
};

export default withStyles(styles)(LoadingSegment);
